import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type ContentfulClientService from 'teacher-ui-client/services/contentful-client'

export default class ResearchReportsRoute extends Route {
  @service contentfulClient!: ContentfulClientService

  async model() {
    const { subscriptionType } = this.modelFor('subscription-type') as ModelForSubscriptionTypeRoute
    const researchReports = await this.contentfulClient.getResearchReports({ subscriptionType })
    return {
      /**
       * - entries are already filtered by subscription type.
       * - matching null retains entries where product is undefined.
       * - Fast Phonics is not included as there is a dedicated page for FP.
       */
      researchReports: researchReports.filter((entry) =>
        ['reading_eggs', 'reading_eggspress', 'mathseeds', null].includes(entry.fields.product ?? null),
      ),
    }
  }
}
